import React, { useState } from 'react';
import '../Headers/Sidebar/Sidebar.scss';
import Home_icon from '../../Assets/Images/home-icon.png';
import { Link } from 'react-router-dom';
import Collapse from 'react-bootstrap/Collapse';
import { IoIosArrowForward, IoIosArrowDown } from 'react-icons/io';
import { AiOutlineShop } from 'react-icons/ai';
import { IoCreateOutline } from 'react-icons/io5';
function VendorItems() {
	const [menuOpenMaster, setMenuOpenMaster] = useState(false);
	const [categoryOpen, setCategoryOpen] = useState(false);
	const [subCategoryOpen, setSubCategoryOpen] = useState(false);
	const [descriptionTypeOpen, setDescriptionTypeOpen] = useState(false);
	const [descriptionNameOpen, setDescriptionNameOpen] = useState(false);
	const [filter, setFilter] = useState(false);
	const [filterTypes, setFilterTypes] = useState(false);
	const [descriptionOpen, setDescriptionOpen] = useState(false);
	const handleOpens = () => {
		setMenuOpenMaster(!menuOpenMaster);
		setCategoryOpen(!categoryOpen);
	};
	return (
		<div className="text-decoration-none">
			<li
				onClick={handleOpens}
				aria-controls="example-collapse-text"
				aria-expanded={menuOpenMaster}
			>
				<div className="d-flex">
					{/* <img className="sidebar-icons" src={Home_icon} /> */}
					<AiOutlineShop className="me-2" />

					<div style={{ fontSize: "14px" }} className="sidebar-text">Vendors</div>
				</div>
				{menuOpenMaster === false ? (
					<IoIosArrowForward className="sidebar-menu-icon" />
				) : (
					<IoIosArrowDown className="sidebar-menu-icon" />
				)}
			</li>

			<Collapse in={menuOpenMaster}>
				<div id="example-collapse-text" className="mx-2">
					{/* <li
            onClick={() => setCategoryOpen(!categoryOpen)}
            aria-controls="example-collapse-text"
            aria-expanded={categoryOpen}
  style={{ fontSize: "14px" }} 
          >
            <div className="sidebar-text">Category</div>
            {categoryOpen === false ? (
              <IoIosArrowForward className="sidebar-menu-icon" />
            ) : (
              <IoIosArrowDown className="sidebar-menu-icon" />
            )}
          </li> */}

					<Collapse in={categoryOpen}>
						<div className="mx-2">
							{/* <li>
                <Link
                  className={"text-dark text-decoration-none"}
        style={{ fontSize: "14px" }} 
                  to="/create-vendor"
                >
                  Create Vendor
                </Link>
              </li> */}

							<li>
								<Link
									className={"text-dark text-decoration-none"}
									style={{ fontSize: "14px" }}
									to="/approve-vendor"
								>
									Approved Vendors
								</Link>
							</li>
							<li>
								<Link
									className={'text-dark text-decoration-none'}
									style={{ fontSize: '13px' }}
									to="/vendor-request"
								>
									Request Vendors
								</Link>
							</li>
							<li>
								<Link
									className={'text-dark text-decoration-none'}
									style={{ fontSize: '13px' }}
									to="/vendor-product"
								>
									Vendors Product
								</Link>
							</li>
							<li>
								<Link
									className={'text-dark text-decoration-none'}
									style={{ fontSize: '13px' }}
									to="/enquiry"
								>
									Product Enquiry
								</Link>
							</li>
						</div>
					</Collapse>

					{/* <li
						// onClick={() => setSubCategoryOpen(!subCategoryOpen)}
						aria-controls="example-collapse-text"
						aria-expanded={subCategoryOpen}
						style={{ fontSize: '13px' }}
					>
						<div className="sidebar-text">

						<Link
							className={'text-dark text-decoration-none'}
							style={{ fontSize: '13px' }}
							to="/vendor-permission"
						>
							Permissions
						</Link>
						</div>
					</li> */}
				</div>
			</Collapse>
		</div>
	);
}

export default VendorItems;
